import { createReducer } from "@reduxjs/toolkit";
import type { UploadState } from "@redux/state/shared-types";
import { uploadSpeakerResume, resetUploadSpeakerResume } from "./upload-speaker-resume";

const initialState: UploadState = { processing: "idle", url: null };

export const uploadSpeakerResumeReducer = createReducer<UploadState>(initialState, builder => {
  builder
    .addCase(uploadSpeakerResume.fulfilled, (state, action) => {
      return {
        ...state,
        processing: "success",
        url: action.payload,
      };
    })
    .addCase(uploadSpeakerResume.pending, state => {
      return {
        ...state,
        processing: "pending",
      };
    })
    .addCase(uploadSpeakerResume.rejected, state => {
      return {
        ...state,
        processing: "failed",
      };
    });
  builder.addCase(resetUploadSpeakerResume, () => {
    return initialState;
  });
});
